RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Company = Marionette.ItemView.extend({
        template: '#adminCompanyTemplate',

        ui: {
            updateDataLink: '.x-update-data',
            deleteLink: '.x-delete-company',
            editLink: '.x-edit-company',
            tooltips: '[data-toggle="tooltip"]'
        },

        events: {
            'click @ui.updateDataLink': 'updateExternalData',
            'click @ui.deleteLink': 'deleteCompany',
            'click @ui.editLink': 'editCompany'
        },

        tagName: 'tr',

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();
        },

        updateExternalData: function () {
            const me = this;
            const deferred = RivalIQ.utils.async.callbackToDeferred(function (error) {
                if (error) {
                    return RivalIQ.execute('alert:danger', `An error occurred updating external data for ${me.model.get('name')}`);
                }

                RivalIQ.execute('alert:info', `Updating external data for ${me.model.get('name')}`);
            });

            me.model.updateExternalData().done(deferred.resolve).fail(deferred.reject);
        },

        deleteCompany: function () {
            const me = this;

            App.companyDeleteModal.show(new views.Delete({
                model: me.model
            }));
        },

        editCompany: function () {
            const me = this;
            App.trigger('company:edit', me.model);
        }
    });
});
